<template>
    <div>
        <section :class="['job-search view-search ', (openState) ? 'open' : 'close']">
            <div class="view-search__btn">
                <v-tooltip
                        top
                        open-delay="400"
                        :disabled="mobile">
                    <v-btn
                            slot="activator"
                            fab depressed small color="primary"
                            class="view-filter-search-btn"
                            @click="openOverlay">
                        <v-icon size="22">search</v-icon>
                    </v-btn>
                    <span class="grey--text text--lighten-3">Search</span>
                </v-tooltip>

            </div>

            <div
                    class="view-search__skrim"
                    @click="closeJobSearchOverlay"/>

            <div class="elevation-5 view-search__overlay">
                <div class="overlay__inner">
                    <div class="overlay__header" >
                        <v-radio-group class="header__radio" row v-model="includeArchive">
                            <v-radio label="Non-Archived" value="active"></v-radio>
                            <v-radio class="archive" label="Archived" value="archived"></v-radio>
                            <v-radio label="All" value="all"></v-radio>
                        </v-radio-group>
                        <v-autocomplete
                                solo dense
                                hide-selected
                                return-object
                                flat
                                color="primary"
                                item-value="id"
                                item-text="name_special"
                                no-data-text="No Jobs Found"
                                placeholder="Search Jobs"
                                v-model="searchModel"
                                :hide-no-data="!hasSearchTermData"
                                :items="searchData"
                                :loading="searchLoading"
                                :search-input.sync="searchTerm"
                                :filter="v => v"

                                ref="searchTermComponent"
                                @keyup.enter="doTextSearch"
                                attach="#autocomplete-attach-item"
                        >

                            <template slot="item" slot-scope="data" @click="closeJobSearchOverlay">
                                <v-list-tile >
                                    <router-link :to="'/jobs/view/' + data.item.id + '/overview'">
                                        {{data.item.name_special}}
                                    </router-link>
                                </v-list-tile>
                            </template>
                        </v-autocomplete>

                        <div class="header__search-button">
                            <v-btn
                                small light
                                :disabled="!searchInputLocal"
                                color="primary"
                                @click="doTextSearchFinal(searchInputLocal)">
                                <v-icon>check</v-icon>
                            </v-btn>
                        </div>
                        <div class="header__results-ind">
                            <span>{{numResults}}</span>
                        </div>

                        <v-icon
                                class="header__icon">search
                        </v-icon>
                    </div>
                    <div id="autocomplete-attach-item"></div>
                    <!--
                    <div class="overlay__results">
                        <div
                            class="results__inner">
                            <div
                                v-for="item in results"
                                :key="generateUniqueHash(item)"
                                class="result__item"
                                @click.stop="$router.push({ name: 'job-overview', params: { jobId: props.item.id } })">{{item.name}}</div>
                        </div>
                    </div>
                    -->
                </div>
            </div>
        </section>
        <v-dialog
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                v-model="openMobileState">

            <v-card color="#0D47A1" dark>
                <v-toolbar color="#0D47A1" dark flat>
                    <span class="white--text label">Search</span>
                    <v-spacer></v-spacer>
                    <v-btn
                            dark fab small
                            depressed flat
                            @click.stop="closeMobileOverlay">
                        <v-icon size="22">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-layout>

                    <v-card-text >
                        <v-autocomplete
                                hide-selected
                                return-object
                                color="white"
                                item-value="id"
                                item-text="name_special"
                                no-data-text="No Jobs Found"
                                placeholder="Search Jobs"
                                v-model="searchModelMobile"
                                :hide-no-data="!hasSearchTermData"
                                :items="searchData"
                                :loading="searchLoading"
                                :search-input.sync="searchTerm"
                                prepend-inner-icon="search"
                                @keyup.enter="doTextSearch"
                                ref="searchTermMobileComponent"

                        >

                            <template slot="item" slot-scope="data">
                                <v-list-tile>
                                    <router-link :to="'/jobs/view/' + data.item.id + '/overview'">
                                        <h5 @click="closeJobSearchOverlay" class="blue--text text--darken-4">
                                            {{data.item.name_special}}
                                            <v-divider></v-divider>
                                        </h5>
                                    </router-link>
                                </v-list-tile>
                            </template>
                        </v-autocomplete>
                    </v-card-text>
                </v-layout>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
    import cloneDeep from 'lodash/cloneDeep'

    import {
        VUEX_JOB_GET_SEARCH,
        VUEX_JOB_GET_SEARCH_SUCCESS,
        VUEX_JOB_GET_SEARCH_FAILURE,
        VUEX_JOB_CLEAR_SEARCH_DATA,
        VUEX_JOB_UPDATE_SEARCH_TERM,
        VUEX_JOBS_TEXT_FILTER_SEARCH
    } from '@/store/constants/jobs'

    import {
        VUEX_UI_SHOW_JOB_SEARCH,
        VUEX_UI_HIDE_JOB_SEARCH,
        VUEX_UI_HIDE_JOB_SEARCH_MOBILE,
        VUEX_UI_SHOW_JOB_SEARCH_MOBILE,
    } from '@/store/constants/ui'

    export default {
        name: 'job-search',
        data: () => ({
            searchModel: '',
            searchModelMobile: '',
            searchInputLocal: '',//local value of search input - used for when hitting enter. the main value is debounced and causes issues with timing
            hasSearchTermData: false,
            includeArchive: 'active',
            debounceSearchTimer: '',
            numResultsToggler: Math.random()
        }),

        watch: {
            searchData: {
                handler: function (val, oldVal) {
                    this.numResultsToggler = Math.random()
                },
                deep: true
            }
        },

        computed: {
            ...mapState({
                openState: state => state.ui.jobSearchOverlay.openState,
                openMobileState: state => state.ui.jobSearchMobileOverlay.openState,

                searchData: state => state.jobs.searchData,
                searchLoading: state => state.jobs.searchLoading,

                mobile: state => state.mobile.mobile
            }),

            numResults() {
                let num = 0
                if (this.numResultsToggler) {
                    num = this.searchData.length
                }
                let ret = num + ' Result'
                if (num != 1) ret += 's'
                return ret
            },

            searchTerm: {
                get() {
                    return this.$store.state.jobs.searchTerm
                },
                set(val) {
                    if (val || val==='') {
                        this.searchInputLocal = val
                    }
                    this.hasSearchTermData = false

                    if (!val) return

                    if (val && val.length > 1) {
                        clearTimeout(this.debounceSearchTimer)
                        this.debounceSearchTimer = setTimeout(function () {
                            let data = []
                            data.q = val
                            data.includeArchive = this.includeArchive

                            if (this.$router.currentRoute.name === 'jobs-requests') {
                                data.mode = "requests"
                            } else {
                                data.mode = "jobs"
                            }

                            this.hasSearchTermData = (data || this.searchLoading) ? true : false
                            this.$store.dispatch('VUEX_JOB_UPDATE_SEARCH_TERM', data)
                        }.bind(this), 800)

                    }
                }
            },
        },
        watch: {
            searchModel(obj) {
                if (!obj && !obj.id) {
                    return
                } else {
                    this.$router.push({name: 'job-overview', params: {jobId: obj.id}})
                }

            },
            searchModelMobile(obj) {
                if (!obj && !obj.id) {
                    return
                } else {
                    this.$router.push({name: 'job-overview', params: {jobId: obj.id}})
                }

            },

        },

        methods: {
            ...mapActions({
                openJobSearchOverlay: VUEX_UI_SHOW_JOB_SEARCH,
                //closeJobSearchOverlay: VUEX_UI_HIDE_JOB_SEARCH,
                openJobSearchOverlayMobile: VUEX_UI_SHOW_JOB_SEARCH_MOBILE,
                hideJobSearchOverlayMobile: VUEX_UI_HIDE_JOB_SEARCH_MOBILE
            }),
            ...mapMutations({
                clearSearchData: VUEX_JOB_CLEAR_SEARCH_DATA
            }),
            searchClick(item) {

            },
            closeJobSearchOverlay() {
                if (this.mobile === true) {
                    this.closeMobileOverlay()
                    this.$store.dispatch('VUEX_JOB_CLEAR_SEARCH_DATA')
                    return
                }
                this.$store.dispatch('VUEX_UI_HIDE_JOB_SEARCH')
                this.$store.dispatch('VUEX_JOB_CLEAR_SEARCH_DATA')
            },
            openOverlay() {
                this.searchInputLocal=''
                if (this.mobile === true) {
                    this.openJobSearchOverlayMobile()
                } else {
                    this.openJobSearchOverlay()
                }
            },
            closeMobileOverlay() {
                this.hideJobSearchOverlayMobile()
            },

            doTextSearch(e) {
                if (e.key === "Enter") {
                    this.doTextSearchFinal(this.searchInputLocal)
                    return false
                }
            },
            doTextSearchFinal(val) {
                if (val) {
                    //dispatch event with value
                    //also include archive with this - we'll need to update the global archive with whatever was chosen
                    this.$store.dispatch(VUEX_JOBS_TEXT_FILTER_SEARCH, {
                        searchTerms: val,
                        includeArchive: this.includeArchive
                    })

                    //clear searches & close overlay
                    this.searchModel = ''
                    this.searchModelMobile = ''
                    this.closeJobSearchOverlay()

                    return true
                } else {
                    return false
                }
            }

        },

    }
</script>
